import { z } from 'zod';

export const attendeeSchema = z.object({
	anrede: z.enum(['Herr', 'Frau', 'Divers']),
	vorname: z.string(),
	nachname: z.string(),
	email: z.union([z.literal('').transform(() => undefined), z.string().email()]).optional(),
});

export type Attendee = z.infer<typeof attendeeSchema>;

export function createAttendee(attendee: Attendee) {
	return attendeeSchema.parse(attendee);
}

export function areAttendeesEqual(attendee1: Attendee, attendee2: Attendee) {
	return (
		attendee1.anrede === attendee2.anrede &&
		attendee1.vorname === attendee2.vorname &&
		attendee1.nachname === attendee2.nachname &&
		attendee1.email === attendee2.email
	);
}
